import { instance } from "apis/interceptor";
import { ResponseType } from "apis/meetings/meeting-reservation";

export type TMessengerInfo = {
  id: string;
  messengerProvider: "SLACK" | "GOOGLE";
  slackBotToken?: string;
  slackUserId?: string;
};

export type TSlackChannel = {
  slackChannelId: string;
  slackChannelName: string;
  slackWorkspaceName: string;
};

//INFO: 연동 messenger 목록 조회
export const getMessengers = async (): Promise<ResponseType<TMessengerInfo[]>> => {
  try {
    const result = await instance.get(`/messengers`);
    return { success: true, data: result.data };
  } catch (e) {
    console.error(e);
    return { success: false, message: "메신저 정보를 가져오는데 실패했습니다." };
  }
};

//INFO: slack 메신저 연동
export const connectSlackMessanger = async (
  slackBotToken: string,
  slackUserId: string
): Promise<ResponseType<boolean>> => {
  try {
    const result = await instance.post(`/messengers/slack`, { slackBotToken, slackUserId });

    if (result.data.result) {
      return { success: true, data: result.data.result };
    } else {
      return { success: false, message: "슬랙 메신저 연동에 실패했습니다." };
    }
  } catch (e) {
    console.error(e);
    return { success: false, message: "슬랙 메신저 연동에 실패했습니다." };
  }
};

//INFO: slack 메신저 연동 해제
export const disconnectSlackMessanger = async (): Promise<ResponseType<boolean>> => {
  try {
    const result = await instance.delete(`/messengers/slack`);

    if (result.data.result) {
      return { success: true, data: result.data.result };
    } else {
      return { success: false, message: "슬랙 메신저 연동 해제에 실패했습니다." };
    }
  } catch (e) {
    console.error(e);
    return { success: false, message: "슬랙 메신저 연동 해제에 실패했습니다." };
  }
};

//INFO: slack channel 정보 조회
export const getSlackChannelInfo = async (slackChannelLink: string): Promise<ResponseType<TSlackChannel>> => {
  try {
    const result = await instance.post(`/messengers/slack/channel`, { slackChannelLink });

    return { success: true, data: result.data };
  } catch (e) {
    console.error(e);
    return { success: false, message: "슬랙 채널 정보를 가져오는데 실패했습니다." };
  }
};
